import React from 'react'
import LtsDropdownIdValue from './lts-dropdown-id-value'
import { enums } from '../../constants'
import utils from '../../utils'
import storage from '../../services/stoage.service'
import _ from 'lodash'

export default function LtsDropdownFormaPagamento(props) {
  const resolveValueFn = (data) => {
    if (data && data.id && data.value) {
      return data
    }
    return resolveOptions().find((v) => v.id === data)
  }

  const resolveOptions = () => {
    if (_.isEmpty(props.options)) {
      const company = storage.getCompany()
      const unit = storage.getUnit()
      const configFormasPagamento = utils.getConfiguracaoFormasPagamento(company, unit)
      return utils.getFormasPagamento(enums.FormasPagamentoBasica, configFormasPagamento)
    }
    return props.options
  }

  return (
    <React.Fragment>
      <LtsDropdownIdValue
        name={props.name}
        label={props.label || 'Forma de Pagamento'}
        value={props.value}
        onChange={props.onChange}
        options={resolveOptions()}
        resolveValueFn={resolveValueFn}
      />
    </React.Fragment>
  )
}
